import React from 'react'

export default function YearComparisonSkeleton({ classCount = 3 }) {
    return (
        <div aria-hidden="true" className="blur pointer-events-none select-none animate-pulse pb-8">
            <div className="flex flex-col gap-4">
                {Array.from({ length: classCount + 1 }, (_, row) => (
                    <div key={row} className="flex flex-col gap-[10px] pb-3 border-b border-b-[#E8E0FF]">
                        <div className="flex items-center gap-2">
                            <div className="min-w-7 max-w-7 h-7 rounded-full bg-lightBG" />
                            <div className="h-5 w-1/3 rounded bg-lightBG" />
                            {row > 0 && <>
                                <div className="h-4 flex-1 rounded bg-lightBG" />
                                <div className="h-[36px] w-40 shrink-0 rounded-full bg-[#86D3FF33]" />
                            </>}
                        </div>
                        <div className="bg-[#F8F8FB] rounded-[4px] p-[2px]">
                            <div className="flex gap-[10px]">
                                <div className="flex flex-col gap-[1px] h-[31px] flex-1">
                                    <div className="flex-1"><div className="h-5 w-3/4 rounded bg-[#6FCC8799]" /></div>
                                    <div className="flex-1 py-[3px]"><div className="h-1 w-1/2 rounded bg-[#FC4C5999]" /></div>
                                </div>
                                <div className="w-[26px]" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
